import { BCMSRecord, Link, ModalOpen, useBCMSModal, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import UIButton from "compid/ui/UIButton";
import { getDefault, getWorkflowSteps } from "compid/workflows/ViewBillWorkflow";
import { Bill } from "model";
import React from "react";
import { ImageAsset } from "res";
import "./styles.css";

/**
 * @function ViewBillPage
 * @param {String} dueBy - The date the bill is/was due by 
 * @param {String} amountdue - The amount of the bill
 * @param {String} balanceDue - The balance due of the bill
 * @param {String} minimumDue - The minimum amount due of the bill
 * @return {React.Component}
 * @exported true
 * @description The main component for ViewBillPage
 */

export default function ViewBillPage(props) {
 
  return(
    <PageView className="view-bill-page">
          <ViewBillPageButtonContainer/>
   </PageView>       
        
  );
}
// Need to create seperate container to provide context for the modalClose
 function ViewBillPageButtonContainer(props) {
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const bill = workflowStep.read("bill");
  const dueDate = bill.date.format('M d');
  const amount = bill.amount.format();
  const balance = bill.balance.format();
  const minDue = bill.minDue.format();
  const navigate = useRoute();
  const billDetailsPath = `/billerDetails/details/${ bill.biller.id }`;
  const done = () => { navigate(billDetailsPath) };

  const openBillImage = () =>{

     window.open(window.location.origin+window.location.pathname + '/res/bill-template.png')
    };
 
  const markAsPaid = () => {
    bill.status = "Paid";
   
    BCMSRecord.batch([
      Bill.update(bill)
    ], workflowStep.globalController);

    workflowStep.navigate(billDetailsPath, { "state" : { "markedBillAsPaid" : true, "bill" : bill } });
  };
  
  const alreadyPaidBillModalData = { markAsPaid: markAsPaid };

 
  
  const { close } = useBCMSModal();
  
  const openBillImageFromModal = () => {
    close("OpenNewWindowModal");
    const pathname = window.location.pathname.replace("index.php", ""); 
    window.open(window.location.origin + pathname + '/res/bill-template.png')
  };



  return( 
    <>
  <p className="page-sub-header semi-bold-text">VIEW BILL</p>
  
  <PageLayoutContainer>
    
    <CenterColumnContainer>
      <BillerView biller={ bill.biller }/>
      
      <div className="bill-image clickable" >
      <ModalOpen id="OpenNewWindowModal" data={ {onClick: openBillImageFromModal } } className="flex-width"><ImageAsset id="BillTemplateImage" /></ModalOpen>
      </div>
      
      <TableView>
        <TableRowView labelClass="semi-bold-text" label="Due By" data={ dueDate } />
        <TableRowView labelClass="semi-bold-text" label="Amount Due" data={ amount } />
        <TableRowView labelClass="semi-bold-text" label="Balance Due" data={ balance } />
        <TableRowView labelClass="semi-bold-text" label="Minimum Due" data={ minDue } />
      </TableView>

      <ButtonContainer className="form-button-container">
            <UIButton className="secondary-button" onClick={ done }>Done</UIButton>
            <ModalOpen id="OpenNewWindowModal" data={ {onClick: openBillImageFromModal } } className="flex-width">
              <UIButton className="primary-button">View bill</UIButton>
            </ModalOpen>
          </ButtonContainer>
      <Link className="text-center semi-bold-text mark-paid-link link-button">
        <ModalOpen id="AlreadyPaidBillModal" data={ alreadyPaidBillModalData }>Mark bill as paid</ModalOpen>
      </Link>
      
    </CenterColumnContainer>
  </PageLayoutContainer>
</>
          
     
  );
}
